/** Central brand constants · update here when rebranding. */
export const BRAND_NAME = "AutoPlus";
export const BRAND_LOGO_SRC = "/autoplus-plusicon.png";
/** White AUTOPLUS wordmark + blue plus · use on dark hero/panels. */
export const BRAND_LOGO_ON_DARK_SRC = "/autoplus-plusicon-white.png";
export const BRAND_FAVICON_SRC = "/favicon-192.png";
export const BRAND_LOGO_ALT = "AutoPlus";
export const SUPPORT_EMAIL = "support@autoplus.com";
export const THEME_STORAGE_KEY = "autoplus-theme";
